import { Image } from '@acme/assets';

export const EmptyState = () => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6">
      <div className="mb-6 h-40 w-40">
        <Image
          name="mailbox"
          width="100%"
          height="100%"
          alt="Mailbox"
          className="object-contain"
        />
      </div>
      <p className="text-base text-gray-500 text-center">Чатов пока нет</p>
    </div>
  );
};
